const initBackgroundVideos = () => {
  const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!isReducedMotion) return;

  const videoEls = document.querySelectorAll('[data-background-video]');
  if (!videoEls.length) return;

  videoEls.forEach((videoEl) => {
    videoEl.removeAttribute('autoplay');
    videoEl.pause();
    videoEl.currentTime = 0;
  });
};

export default initBackgroundVideos;
